module.exports = __webpack_public_path__ + "img/incydenty_inactive.783d5f92.svg";